import StickyContainer from "../../../components/layout/sticky-container";
import React, { useEffect } from "react";

import HistoryButton from './../../../components/buttons/history-button';
import GrantApplicationProgress from './../components/grant-application-progress';

const STATUS_PENDING = 'pending';

const STATUS_APPROVED = 'approved';

const STATUS_REJECTED = 'rejected';

const STATUS_SCORING = 'scoring';

const STATUS_AMENDMENTS_REQUIRED =  'amendments required';

const STATUS_CLAIM_PROCESSED = 'claim processed';

const STATUS_OFFER_LETTER_SENT = 'offer letter sent';

const STATUS_OFFER_ACCEPTED = 'offer accepted';

const STATUS_OFFER_REJECTED = 'offer rejected';

const STATUS_DOCUMENTS_REQUESTED = 'documents requested';

const STATUS_DOCUMENTS_RECEIVED = 'documents received';

const STATUS_CLAIM_SUBMITTED_FOR_PAYMENT = 'claim submitted for payment';

const STATUS_COMPLETED = 'completed';

const STATUS_CLAIM_APPROVED_FOR_PAYMENT = 'claim approved for payment';


const OPTIONS = {
    STATUS_PENDING: {
        value: STATUS_PENDING,
        label: 'Application submitted for review',
        message: 'Your application is currently being reviewed by the claims team. Any clarifications will be highlighted on these pages before a decision is reached.',
        type: 'pending'
    },
    STATUS_AMENDMENTS_REQUIRED: {
        value: STATUS_AMENDMENTS_REQUIRED,
        label: 'Amendments Required',
        message: 'The assessment team have requested amends to be made to your application. Please review the sections where prompted and submit your changes.',
        type: 'pending'
    },
    STATUS_SCORING: {
        value: STATUS_SCORING,
        label: 'Application submitted for review',
        message: 'Your application is currently being reviewed by the claims team. Any clarifications will be highlighted on these pages before a decision is reached.',
        type: 'pending'
    },
    STATUS_APPROVED: {
        value: STATUS_APPROVED,
        label: 'Application Accepted',
        message: 'Your application has been accepted by the Grant Claims team. You can keep up to date with the progress of your application in the Grants section of your myEB account.',
        type: 'approved'
    },
    STATUS_REJECTED: {
        value: STATUS_REJECTED,
        label: 'Application Rejected',
        message: '',
        type: 'rejected'
    },
    STATUS_CLAIM_PROCESSED: {
        value: STATUS_CLAIM_PROCESSED,
        label: 'Application Accepted: Claim processed',
        message: `If you have received this update before receiving your claim payment, please contact the Grant Claims team by email, stating your application serial number in the email subject.`,
        type: 'approved'
    },
    STATUS_OFFER_LETTER_SENT: {
        value: STATUS_OFFER_LETTER_SENT,
        label: 'Application Accepted: Offer letter sent',
        message: 'You will receive an offer letter via email related to your Grant claim. Once this has been signed and returned, your claim will proceed.',
        type: 'approved'
    },

    STATUS_OFFER_ACCEPTED: {
        value: STATUS_OFFER_ACCEPTED,
        label: 'Application Accepted: Offer Accepted',
        message: 'Please refer to your grant offer letter and the Grant terms and conditions for full details. Please submit your grant claim via email within 30 days of your estimated completion date.',
        type: 'approved'
    },
    STATUS_OFFER_REJECTED: {
        value: STATUS_OFFER_REJECTED,
        label: 'Application Accepted: Offer rejected',
        message: 'Your application decision has been changed from accepted to rejected during the claims process. You will be contacted by a Grant Manager about this decision in due course.',
        type: 'rejected'
    },

    STATUS_DOCUMENTS_REQUESTED: {
        value: STATUS_DOCUMENTS_REQUESTED,
        label: 'Application Accepted: Grant documents requested',
        message: 'Documents have been requested or queried to process your application - you will be contacted by the claims team about this. Please upload any required documents using the ‘Document Uploads’ button.',
        type: 'pending'
    },
    STATUS_DOCUMENTS_RECEIVED: {
        value: STATUS_DOCUMENTS_RECEIVED,
        label: 'Application Accepted: Grant documents Received',
        message: 'Your documents have been successfully received by the claims team. Your grant claim will be reviewed by the claims team, and you’ll be contacted if there are any queries to be addressed. Otherwise, you’ll be notified when the claim is approved for payment.',
        type: 'approved'
    },
    STATUS_CLAIM_SUBMITTED_FOR_PAYMENT: {
        value: STATUS_CLAIM_SUBMITTED_FOR_PAYMENT,
        label: 'Application Accepted: Claim submitted for payment',
        message: `You should receive your payment within 1 week, if payment is not received after 1 week please contact us so we can investigate.`,
        type: 'approved'
    },
    STATUS_COMPLETED: {
        value: STATUS_COMPLETED,
        label: 'Application Accepted: Completed',
        message: `If you have received this update before receiving your claim payment, please contact the Grant Claims team by email, stating your application serial number in the email subject.`,
        type: 'approved'
    },
    STATUS_CLAIM_APPROVED_FOR_PAYMENT: {
        value: STATUS_CLAIM_APPROVED_FOR_PAYMENT,
        label: 'Application Accepted: Claim approved for Payment',
        message: 'The Grant team have reviewed your grant claim documents and has approved them for payment. You will be notified when BMBC Finance has confirmed your grant claim is on its next payment run. This should happen within 30 days of submitting your complete and complete and correct grant claim documents.',
        type: 'approved'
    },


};

function GrantsState({ title, subtitle, type, icon }) {
    const TYPES = [
        'approved',
        'pending',
        'rejected'
    ]

    return (
            <div className={`grants-state grants-state--${ !TYPES.includes(type) ? 'default' : type }`}>
                <div className='grants-state__left'>
                    <p className="grants-state__title">{ title }</p>
                    <p className="grants-state__subtitle">{ subtitle }</p>
                </div>
                <div className='grants-state__right'>
                    { icon }
                </div>
            </div>
    )
}

export default class GrantsStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPopup: false
        }
    }

    getOption() {
        const option = _.find(OPTIONS, item => {
            return item.value === this.props.application.status;
        });

        return option === undefined ? {} : option;
    }

    getMessage() {
        const option = this.getOption();

        return <p>{option.message}</p>;
    }

    getTitle() {

        const option = this.getOption();

        return option.label;
    }

    getType() {
        const option = this.getOption();

        return option.type;
    }

    getRejectionMessage() {
        const rejectStatus = _.find(OPTIONS, item => {
            return item.value === STATUS_REJECTED;
        });
        if (rejectStatus) {
            return this.props.application.rejection_message !== null ? this.props.application.rejection_message : '';
        }
    }

    setPopup(pop) {
        this.setState({
            showPopup: pop
        })
    }

    render() {
        if (this.props.application.status === 'in progress') return '';

        return (
            <>
                { this.state.showPopup && this.state.showPopup }

                <GrantsState title={this.getTitle()}
                           subtitle={this.props.application.status === 'rejected' ? this.getRejectionMessage() : this.getMessage()}
                           type={this.getType()}
                           icon={<HistoryButton mobile={true} responsive={false}
                                                onClick={() => this.setPopup(<GrantApplicationProgress application={this.props.application} setPopup={this.setPopup.bind(this)}/>)}>
                           </HistoryButton>}/>
            </>

        )
    }
}
